import type { CommissionAllocationAgreementNode } from "../allocations/types";
import type { CommissionProgramConsentNode } from "../consents/types";

const acmeCampaignSummary = {
  id: "commission-campaign-2026-acme",
  editionYear: 2026,
  status: "ACTIVE" as const,
  attributionModel: "FACILITY" as const,
  partner: { id: "commission-partner-acme", name: "Acme Golf Sponsors" },
  program: { id: "commission-program-grp", name: "Golf Retirement Plus" }
};

export const commissionProgramConsentFixtures: CommissionProgramConsentNode[] = [
  {
    id: "commission-consent-ada-2026",
    commissionCampaignId: "commission-campaign-2026-acme",
    crmPersonId: "person-ada",
    attributionModel: "FACILITY",
    ownership: "OWNER",
    crmFacilityId: "facility-oak-hills",
    facilityName: "Oak Hills Golf Club",
    startsAt: "2026-01-01T00:00:00Z",
    endsAt: null,
    status: "ACTIVE",
    person: { id: "person-ada", displayName: "Ada Lovelace", pgaId: "12345678" },
    campaign: acmeCampaignSummary
  },
  {
    id: "commission-consent-bobby-2025",
    commissionCampaignId: "commission-campaign-2025-acme",
    crmPersonId: "person-bobby",
    attributionModel: "PERSONAL",
    ownership: "NON_OWNER",
    startsAt: "2025-01-01T00:00:00Z",
    endsAt: "2025-12-31T23:59:59Z",
    status: "ENDED"
  }
];

export const commissionIaaFixtures: CommissionAllocationAgreementNode[] = [
  {
    id: "commission-iaa-ada-2026",
    commissionCampaignId: "commission-campaign-2026-acme",
    receiverCrmPersonId: "person-ada",
    crmFacilityId: "facility-oak-hills",
    facilityName: "Oak Hills Golf Club",
    status: "ACTIVE",
    effectiveStart: "2026-01-01T00:00:00Z",
    effectiveEnd: null,
    splits: [
      {
        id: "commission-split-ada",
        crmPersonId: "person-ada",
        pgaId: "12345678",
        displayName: "Ada Lovelace",
        splitPercent: 100,
        hasActiveFaa: true
      }
    ]
  },
  {
    id: "commission-iaa-bobby-2026",
    commissionCampaignId: "commission-campaign-2026-acme",
    receiverCrmPersonId: "person-bobby",
    crmFacilityId: "facility-pine-valley",
    facilityName: "Pine Valley Country Club",
    status: "DRAFT",
    effectiveStart: "2026-04-01T00:00:00Z",
    effectiveEnd: null,
    splits: [
      {
        id: "commission-split-bobby",
        crmPersonId: "person-bobby",
        pgaId: "87654321",
        displayName: "Bobby Jones",
        splitPercent: 60,
        hasActiveFaa: true
      },
      {
        id: "commission-split-charlie",
        crmPersonId: "person-charlie",
        pgaId: "11223344",
        displayName: "Charlie Park",
        splitPercent: 30,
        hasActiveFaa: false
      }
    ]
  }
];
